/**
 * Exponential moving average of frame rate, sampled from frame delta times.
 */
export class FpsMeter {
  private ema = 60;
  private readonly alpha: number;

  constructor(smoothing = 0.1) {
    this.alpha = smoothing;
  }

  /** Feed a frame delta (seconds). Returns the smoothed fps. */
  sample(dt: number): number {
    if (dt > 0) {
      const instant = 1 / dt;
      this.ema += this.alpha * (instant - this.ema);
    }
    return this.ema;
  }

  get fps(): number {
    return this.ema;
  }
}
